import React from 'react';
import { shape, node, string, bool } from 'prop-types';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import ButtonBase from 'material-ui/ButtonBase';
import T from '../Text';
import { white, green, green2, red as red1, red2, gray2, darkGray } from '../styles/colors';
import {
  label as labelStyles,
  labelS,
  fullWidth,
  sizeL,
  sizeM,
  sizeS,
  sizeXS,
} from './styles';
import { reduceClasses } from '../utils/testUtils';

export const styles = ({ breakpoints }) => ({
  defaultLabel: {
    '& > span': labelStyles,
  },
  smallLabel: {
    '& > span': labelS,
  },
  root: {
    backgroundColor: green,
    '& > span': {
      color: white,
    },
    [breakpoints.up('sm')]: {
      '&:hover': {
        backgroundColor: green2,
      },
    },
  },
  red: {
    backgroundColor: red1,
    '& > span': {
      color: white,
    },
    [breakpoints.up('sm')]: {
      '&:hover': {
        backgroundColor: red2,
      },
    },
  },
  disabled: {
    backgroundColor: gray2,
    '& > span': {
      color: darkGray,
      opacity: 0.36,
    },
  },
  sizeL: sizeL(breakpoints),
  sizeM,
  sizeS,
  sizeXS,
  fullWidth,
});

const AccentButton = ({
  classes: classesProp,
  className: classNameProp,
  label,
  disabled,
  red,
  l,
  s,
  xs,
  full,
  small,
  children,
  test,
  ...other
}) => {
  const classes = test ? reduceClasses(classesProp) : classesProp;

  return (
    <ButtonBase
      className={classNames(
        {
          [classes.disabled]: disabled,
          [classes.red]: red,
          [classes.sizeL]: l,
          [classes.sizeM]: !l && !s && !xs && !small,
          [classes.sizeS]: s,
          [classes.sizeXS]: xs || small,
          [classes.fullWidth]: full,
        },
        classes.root,
        s || xs ? classes.smallLabel : classes.defaultLabel,
        classNameProp,
      )}
      disabled={disabled}
      focusRipple
      {...other}
    >
      {
        children || <T test={test}>{label}</T>
      }
    </ButtonBase>
  );
};

AccentButton.propTypes = {
  /** Optional children. Only rendered if no label was provided. */
  children: node,
  /** Classes from the styleSheet generated. */
  classes: shape({}).isRequired,
  /** Useful to extend the styleSheet applied to the button. */
  className: string,
  /** Red button version styles. */
  red: bool,
  /** Large button styles (Button L). */
  l: bool,
  /** Small button styles (Button S). */
  s: bool,
  /** Smaller button styles (Button S padding 16px). */
  xs: bool,
  /** Smaller padding values and font-size. */
  small: bool,
  /** Set button width to 100% to fit its container. */
  full: bool,
  /** Label for the button. */
  label: string,
  /** If true, the button will be disabled. */
  disabled: bool,
  /** Useful for snapshot testing. */
  test: bool,
};

AccentButton.defaultProps = {
  children: undefined,
  className: undefined,
  red: false,
  l: false,
  s: false,
  xs: false,
  small: false,
  full: false,
  label: undefined,
  disabled: false,
  test: false,
};

export default withStyles(styles)(AccentButton);
